/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Change-of-tenancy status, consistent with move-in / move-out. The backend collapses its internal enrolment lifecycle to this set; branch on this, not on errorMessage.
 */
export type MoveWithUsChangeOfTenancyStatus =
  (typeof MoveWithUsChangeOfTenancyStatus)[keyof typeof MoveWithUsChangeOfTenancyStatus]

export const MoveWithUsChangeOfTenancyStatus = {
  PENDING: "PENDING",
  SUCCESSFUL: "SUCCESSFUL",
  FAILED: "FAILED",
} as const
